var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 8.1665,
    rx: 8.16667,
    ry: 3.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 15.1665C5.83337 15.1665 5.83337 17.9002 5.83337 19.8332C5.83337 21.7662 9.48972 23.3332 14 23.3332C18.5104 23.3332 22.1667 21.7662 22.1667 19.8332C22.1667 18.8683 22.1667 15.1665 22.1667 15.1665",
    stroke: "white",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 8.1665C5.83337 8.1665 5.83337 12.0668 5.83337 13.9998C5.83337 15.9328 9.48972 17.4998 14 17.4998C18.5104 17.4998 22.1667 15.9328 22.1667 13.9998C22.1667 13.035 22.1667 8.1665 22.1667 8.1665",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaking);
export default __webpack_public_path__ + "static/media/staking.28a54f155cde5771ba1c5dabd71646fe.svg";
export { ForwardRef as ReactComponent };